import makeList from './makeList.js'

let viewFloor = '地学棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '地学棟入口',
        file: './data/I10f.JPG',
        rotation: 67.05809957126333,
        link: [
          {
            file: './data/I10c.JPG',
            position: [ 1832.0018571179173, 498.67806617950737, -4615.189708693892 ],
          },
          {
            file: './data/I10e.JPG',
            position: [ 3391.4963559236176, 490.62478468467907, -3631.676829075392 ],
          },
          {
            file: './data/I10.JPG',
            position: [ -4731.047645350183, 1576.6323213865562, 240.3542220298996 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 551.2820512820514, 412.9999999999999 ],
        },
      },
      { description: '地学棟',
        file: './data/I10c.JPG',
        rotation: 34.217038280756505,
        link: [
          {
            file: './data/I10f.JPG',
            position: [ 1517.1531596649552, 494.3940554688446, 4734.338363715232 ],
          },
          {
            file: './data/I10d.JPG',
            position: [ 2487.45628147117, 227.54488192819093, 4326.498230412975 ],
          },
          {
            file: './data/I10e.JPG',
            position: [ 3144.651008670213, 484.85835970110185, 3844.608440130715 ],
          },
          {
            file: './data/I10a.JPG',
            position: [ -2694.4943674218453, 89.31371120959528, -4199.64244488543 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 535.8974358974359, 341.2051282051283 ],
        },
      },
      { description: '地学棟 験震室',
        file: './data/I10d.JPG',
        rotation: -10.963298197501073,
        link: [
          {
            file: './data/I10c.JPG',
            position: [ -3151.3159033944926, -263.2841069301771, -3859.8026528523765 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 451.2820512820513, 407.8717948717948 ],
        },
      },
      { description: '地学棟 倉庫',
        file: './data/I10e.JPG',
        rotation: -42.63303483712684,
        link: [
          {
            file: './data/I10f.JPG',
            position: [ -4020.113023626947, -73.21398869020094, 2965.199352975266 ],
          },
          {
            file: './data/I10c.JPG',
            position: [ -4881.381850939484, -7.4601200186863625, 1073.3444573936822 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 458.974358974359, 346.33333333333337 ],
        },
      },
      { description: '地学棟(1)',
        file: './data/I10a.JPG',
        rotation: -150.385347368791,
        link: [
          {
            file: './data/I10c.JPG',
            position: [ 3585.8032011694436, -110.9052389533566, 3469.420049117056 ],
          },
          {
            file: './data/I10b.JPG',
            position: [ -4575.077675660431, -397.76207581237765, 1969.7809130348553 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 589.7435897435898, 295.0512820512821 ],
        },
      },
      { description: '地学棟(2)',
        file: './data/I10b.JPG',
        rotation: 12.707109465521823,
        link: [
          {
            file: './data/I10a.JPG',
            position: [ 4562.0843772217295, 201.93920481121734, -2026.2736695320282 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 809.7062579821201, 366.53895274584926 ],
          syowaZoom: [ 623.0769230769231, 328.38461538461536 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
